import React, { useEffect, useState } from 'react';
import { Grid, Slider, TextField } from '@mui/material';
import { NumericFormat } from 'react-number-format';
import { ruble } from '../../helpers/formatHelper';

const ProfitCalculator = () => {
  const [borrowerAmount, setBorrowerAmount] = React.useState<
    number | string | Array<number | string>
  >(10);
  const [averageSum, setAverageSum] = React.useState<
    number | string | Array<number | string>
  >(1000000);
  const [profit, setProfit] = useState(0);

  useEffect(() => {
    const p = (+averageSum / 100) * +borrowerAmount;
    setProfit(p);
  }, [averageSum, borrowerAmount]);

  const handleSliderChange = (
    newValue: number | number[],
    cb: (v: number | number[]) => void
  ) => {
    cb(newValue);
  };

  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    cb: (v: number | string) => void
  ) => {
    cb(event.target.value === '' ? '' : Number(event.target.value));
  };

  const handleBlur = () => {
    if (borrowerAmount < 0) {
      setBorrowerAmount(0);
    } else if (borrowerAmount > 100) {
      setBorrowerAmount(100);
    }
  };

  return (
    <Grid container spacing={3} alignItems="center">
      <Grid item xs={12} md={4}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12}>
            <TextField
              label="Количество целевых заёмщиков"
              variant="outlined"
              fullWidth
              value={borrowerAmount}
              size="small"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleInputChange(e, setBorrowerAmount)
              }
              onBlur={handleBlur}
            />
          </Grid>
          <Grid item xs>
            <Slider
              min={1}
              max={100}
              step={1}
              value={typeof borrowerAmount === 'number' ? borrowerAmount : 0}
              onChange={(e, v) => handleSliderChange(v, setBorrowerAmount)}
              aria-labelledby="input-slider"
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12}>
            <NumericFormat
              customInput={TextField}
              label="Средняя сумма займа"
              variant="outlined"
              fullWidth
              value={+averageSum}
              thousandSeparator=" "
              suffix=" ₽"
              size="small"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleInputChange(e, setAverageSum)
              }
              onBlur={handleBlur}
            />
          </Grid>
          <Grid item xs>
            <Slider
              step={100000}
              min={1000000}
              max={10000000}
              value={typeof averageSum === 'number' ? averageSum : 0}
              onChange={(e, v) => handleSliderChange(v, setAverageSum)}
              aria-labelledby="input-slider"
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid container spacing={2} alignItems="center" justifyContent="center">
          <Grid container alignItems="center" justifyContent="center">
            <Grid item>Ожидаемый доход</Grid>
          </Grid>
          <Grid item xs={12} style={{ fontSize: '30px' }}>
            {ruble(profit)}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ProfitCalculator;
